import { render, staticRenderFns } from "./ErrorWarning.vue?vue&type=template&id=026e8216&scoped=true"
import script from "./ErrorWarning.vue?vue&type=script&lang=ts"
export * from "./ErrorWarning.vue?vue&type=script&lang=ts"
import style0 from "./ErrorWarning.vue?vue&type=style&index=0&id=026e8216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026e8216",
  null
  
)

export default component.exports